import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    /** 企业微信登录 token */
    token: localStorage.getItem('ww_token') || '',

    /** 企业微信用户信息 */
    userInfo: JSON.parse(localStorage.getItem('ww_user') || 'null')
  },

  getters: {
    /** 是否已登录 */
    isAuthenticated(state) {
      return !!state.token
    },

    /** 当前用户名 */
    userName(state) {
      return state.userInfo?.name || state.userInfo?.UserId || ''
    }
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('ww_token', token)
    },

    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('ww_user', JSON.stringify(userInfo))
    },

    CLEAR_AUTH(state) {
      state.token = ''
      state.userInfo = null
      localStorage.removeItem('ww_token')
      localStorage.removeItem('ww_user')
    }
  },

  actions: {
    /** 登录：保存 token 和用户信息 */
    login({ commit }, { token, userInfo }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
    },

    /** 登出 */
    logout({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
})
